import curd from '../curd'

const BASE_PATH = '/alarm'

export default curd(BASE_PATH, {
  getList: query => ({
    url: `${BASE_PATH}/list`,
    method: 'POST',
    data: query
  }),
  getDeviceList: query => ({
    url: `${BASE_PATH}/device/status/list`,
    method: 'POST',
    data: query
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/OperationsAlarm.js